<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{ name: 'Jobs' }">
              <h4 class="ms-2">
                {{ label.pages.recruitmentAdvertisement }}
              </h4>
            </b-link>
            /
            <h4 class="me-2">
              {{ $route.meta.label }}
              <small class="fw1">
                {{ label.pages.requestJobInfo }}
              </small>
            </h4>
          </b-col>
          <b-col sm="2" class="text-start">
            <a
              @click="$router.go(-1)"
              v-b-tooltip.hover.right
              :title="label.pages.previousPage"
              class="mouse-change pe-3"
            >
              <b-icon
                icon="arrow-left-square-fill"
                variant="ps-base"
                scale="1.2"
                class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <DxDataGrid
            :show-row-lines="true"
            :show-column-lines="true"
            :show-borders="true"
            :row-alternation-enabled="true"
            :rtl-enabled="label.direction === 'rtl' ? true : false"
            :data-source="jobRequest"
            :columns="jobRequestFields"
            :remote-operations="true"
            :column-auto-width="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            column-resizing-mode="widget"
            :hover-state-enabled="true"
            :noDataText="checkData"
            @toolbar-preparing="onToolbarPreparing($event)"
            key-expr="id"
            class="ps_Table"
            :height="dataGridHeight - 70"
          >
            <DxSearchPanel
              :visible="true"
              :width="240"
              :placeholder="label.pages.search"
            />
            <DxColumnChooser :enabled="true" mode="dragAndDrop" />
            <DxExport :enabled="true" />
            <template #btnRGroup>
              <b-row style="margin-top: -15px">
                <b-col cols="5" class="mt-3">
                  <date-picker
                    class="ps_datePicker p-datePicker-leave"
                    color="#6b53ad"
                    input-class="p-datePicker-input-leave"
                    :auto-submit="true"
                    v-model="fromDateLocal"
                    :clearable="true"
                  >
                    <div slot="label">
                      <span style="font-size: 9pt"
                        >{{ label.pages.fromDate }}
                      </span>
                    </div>
                  </date-picker>
                </b-col>
                <b-col cols="5" class="mt-3">
                  <date-picker
                    class="ps_datePicker p-datePicker-leave"
                    color="#6b53ad"
                    input-class="p-datePicker-input-leave"
                    :auto-submit="true"
                    v-model="toDateLocal"
                    :clearable="true"
                  >
                    <div slot="label">
                      <span style="font-size: 9pt">{{
                        label.pages.toDate
                      }}</span>
                    </div>
                  </date-picker>
                </b-col>
                <b-col cols="2" class="mt-3">
                  <b-button
                    variant="ps-second"
                    class="py-1"
                    size="sm"
                    v-b-tooltip.hover
                    @click="reloadData"
                    :title="label.pages.search"
                  >
                    <b-icon icon="search" />
                  </b-button>
                </b-col>
              </b-row>
            </template>
            <template #radif="{ data }">
              <div>
                {{ data.rowIndex + 1 }}
              </div>
            </template>
            <template #image="{ data }">
              <div>
                <img
                        :src="data.data.imageAddress"
                        alt="لوگو"
                        class="ps_table_inside_img"
                />
              </div>
            </template>
            <template #btnGroup>
              <div>
                <b-row class="ms-2">
                  <b-col cols="auto" class="px-1">
                    <b-button
                      variant="ps-success"
                      class="py-1 pb-2"
                      size="sm"
                      v-b-tooltip.hover
                      :title="label.buttons.addJobRequest"
                      @click="add()"
                    >
                      <b-icon icon="plus" scale="2" color="#fff"></b-icon>
                    </b-button>
                  </b-col>
                  <b-col cols="auto" class="px-1">
                    <b-button
                      variant="ps-secondary"
                      class="py-1 pb-2"
                      size="sm"
                      v-b-tooltip.hover
                      :title="label.table.reload"
                      @click="reloadData"
                    >
                      <b-icon
                        icon="arrow-repeat"
                        scale="1.5"
                        color="#fff"
                      ></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </template>
            <template #actions="{ data }">
              <b-row class="justify-content-center">
                <b-col cols="auto" class="px-1">
                  <button
                    @click="showDegreeDetail(data)"
                    :id="'degreeBtnTlp-' + data.data.id"
                  >
                    <b-icon
                      icon="book-fill"
                      scale="1.1"
                      variant="ps-tools-icon"
                    ></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'degreeBtnTlp-' + data.data.id"
                  >
                    {{ label.pages.educationalRecords }}
                  </b-tooltip>
                </b-col>
                <b-col cols="auto" class="px-1">
                  <button
                    @click="showJobDetail(data)"
                    :id="'jobBtnTlp-' + data.data.id"
                  >
                    <b-icon
                      icon="collection-fill"
                      scale="1.1"
                      variant="ps-options-icon"
                    ></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'jobBtnTlp-' + data.data.id"
                  >
                  {{ label.pages.workExperience }}
                  </b-tooltip>
                </b-col>
                <b-col cols="auto" class="px-1">
                  <button
                    :id="'addBtnTlp-' + data.data.id"
                    @click="statusConfirm(data)"
                  >
                    <b-icon
                      icon="check-square-fill"
                      scale="1.1"
                      variant="info"
                    ></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'addBtnTlp-' + data.data.id"
                  >
                  {{ label.pages.changeAdStatus }}
                  </b-tooltip>
                </b-col>
                <b-col cols="auto" class="px-1">
                  <button
                    @click="edit(data)"
                    :id="'editBtnTlp-' + data.data.id"
                  >
                    <b-icon
                      icon="dash-square-fill"
                      scale="1.1"
                      variant="ps-edit-icon"
                    ></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'editBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.edit }}
                  </b-tooltip>
                </b-col>
                <b-col cols="auto" class="px-0">
                  <button
                    @click="delConfirm(data)"
                    :id="'deleteBtnTlp-' + data.data.id"
                  >
                    <b-icon
                      icon="x-square-fill"
                      scale="1.1"
                      variant="ps-delete-icon"
                    ></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'deleteBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.delete }}
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <DxLoadPanel :enabled="true" />
            <DxScrolling mode="virtual" />
          </DxDataGrid>
        </b-card-text>
      </b-card-body>
    </b-card>

    <!--  details degree Modal -->
    <b-modal
      dir="rtl"
      v-model="detailModal"
      header-bg-variant="primary"
      size="lg"
      hide-footer
      centered
    >
      <template #modal-header>
        <h4 style="color: white">{{ label.pages.educationalRecords }}</h4>
        <button
          class="ps-closeModalBtn"
          @click="detailModal = false"
          id="detailModalCloseTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip noninteractive target="detailModalCloseTlp" triggers="hover">
          {{ label.buttons.closeModal }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row class="p-2" v-if="detailForm && detailForm.length > 0">
          <DxDataGrid
            :show-row-lines="true"
            :show-column-lines="true"
            :show-borders="true"
            :row-alternation-enabled="true"
            :rtl-enabled="true"
            :data-source="detailForm"
            :columns="detailFields"
            :remote-operations="true"
            :column-auto-width="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            column-resizing-mode="widget"
            :hover-state-enabled="true"
            class="ps_Table"
          >
            <DxLoadPanel :enabled="true" />
          </DxDataGrid>
        </b-row>
        <b-row v-else>
          <p class="text-danger fs9 text-center fw2">
            رکوردی برای این قسمت ثبت نشده است !!!
          </p>
        </b-row>
      </b-container>
    </b-modal>

    <!--  details job Modal -->
    <b-modal
      dir="rtl"
      v-model="detailJobModal"
      header-bg-variant="primary"
      size="lg"
      hide-footer
      centered
    >
      <template #modal-header>
        <h4 style="color: white">{{ label.pages.workExperience }}</h4>
        <button
          class="ps-closeModalBtn"
          @click="detailJobModal = false"
          id="detailModalCloseTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip noninteractive target="detailModalCloseTlp" triggers="hover">
          {{ label.buttons.closeModal }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row class="p-2" v-if="detailJobForm && detailJobForm.length > 0">
          <DxDataGrid
            :show-row-lines="true"
            :show-column-lines="true"
            :show-borders="true"
            :row-alternation-enabled="true"
            :rtl-enabled="true"
            :data-source="detailJobForm"
            :columns="detailJobFields"
            :remote-operations="true"
            :column-auto-width="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            column-resizing-mode="widget"
            :hover-state-enabled="true"
            class="ps_Table"
          >
            <DxLoadPanel :enabled="true" />
          </DxDataGrid>
        </b-row>
        <b-row v-else>
          <p class="text-danger fs9 text-center fw2">
            رکوردی برای این قسمت ثبت نشده است !!!
          </p>
        </b-row>
      </b-container>
    </b-modal>

    <!-- Change Status Modal -->
    <b-modal dir="rtl" v-model="statusModal" hide-header size="sm" centered>
      <b-container fluid>
        <b-row class="mt-2">
          <b-col cols="12">
            <p class="fs-normal text-center">
              {{ label.pages.sureChangeAdsStatus }}
            </p>
          </b-col>
          <b-col cols="12" class="text-center">
            <label for="display" class="ps_label ms-3">
              {{ label.form.display }}
            </label>
            <label class="ps-switch">
              <input type="checkbox" id="display" v-model="status" />
              <span class="slider round"></span>
            </label>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="statusModal = false"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-info"
              size="sm"
              class="mx-1"
              @click="changeStatus"
            >
              <b-spinner small v-if="loadingBtn"></b-spinner>
              <span v-else>
                <b-icon icon="check2-circle" class="ms-1" />
                {{ label.buttons.sureDoIt }}
              </span>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!--  Add Modal -->
    <b-modal
      :dir="label.direction"
      v-model="addModal"
      header-bg-variant="ps-success"
      centered
      size="xl"
    >
      <template #modal-header>
        <h4 class="text-white fw1">{{ label.pages.addJobRequest }}</h4>
        <button
          class="ps-closeModalBtn"
          @click="addModal = false"
          v-b-tooltip.hover
          :title="label.buttons.closeModal"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
      </template>
      <b-container fluid>
        <b-row>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="FirstName" class="ps_label">
              {{ label.form.firstName }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="FirstName"
              size="sm"
              v-model="form.FirstName"
              type="text"
              class="text-end"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="LastName" class="ps_label">
              {{ label.form.lastName }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="LastName"
              size="sm"
              v-model="form.LastName"
              type="text"
              class="text-end"
            />
          </b-col>
          <b-col
            lg="4"
            md="6"
            sm="12"
            class="d-flex justify-content-center align-items-center mt-3"
          >
            <label for="Gender" class="ps_label ps-3">
              {{ label.form.gender }}:
            </label>
            <b-form-radio-group v-model="form.Gender" size="lg" class="d-flex">
              <b-form-radio :value="1" id="legal">
                <label for="legal" class="ps_label pe-0">
                  {{ label.form.sir }}
                </label>
              </b-form-radio>
              <b-form-radio :value="2" id="real" @change="clearSelect">
                <label for="real" class="ps_label pe-0">
                  {{ label.form.lady }}
                </label>
              </b-form-radio>
            </b-form-radio-group>
          </b-col>

          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="BirthdateLocal" class="ps_label">
              {{ label.form.birthDate }}
            </label>
            <date-picker
              v-model="form.BirthdateLocal"
              :clearable="true"
              :editable="true"
              :auto-submit="true"
              type="date"
              color="#6AA435"
              class="ps_datePicker"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="province" class="ps_label">
              {{ label.form.province }}
              <span class="ps_label_star">*</span>
            </label>
            <v-select
              input-id="province"
              :options="provinceOptions"
              v-model="form.ProvinceId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
              >ّ
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyProvince }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="MaritalStatus" class="ps_label">
              {{ label.form.maritalStatus }}
            </label>
            <v-select
              input-id="MaritalStatus"
              :options="MaritalOptions"
              v-model="form.MaritalStatus"
              :clearable="true"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
            >
              <template #no-options>
                <span class="p-select-no-option">{{
                  label.captions.emptyList
                }}</span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="UserId" class="ps_label">
              {{ label.form.user }}
              <span class="ps_label_star">*</span>
              <b-icon
                icon="question-circle-fill"
                scale="1.2"
                variant="ps-base"
                class="me-1 mouse-question"
                id="jobAddUserGuide"
              />
              <b-popover
                boundary="#app"
                placement="top"
                noninteractive
                triggers="hover"
                target="jobAddUserGuide"
                dir="rtl"
              >
                {{ label.guide.jobSeeker }}
              </b-popover>
            </label>
            <v-select
              input-id="UserId"
              :options="websiteUserOptions"
              v-model="form.UserId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
              >ّ
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyList }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="ActivityField" class="ps_label">
              {{ label.form.specializedNeeds }}
              <span class="ps_label_star">*</span>
            </label>
            <v-select
              input-id="ActivityField"
              :options="activityFieldOptions"
              v-model="form.ActivityFieldId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
              >ّ
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyList }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="Degree" class="ps_label">
              {{ label.form.educationDegree }}
              <span class="ps_label_star">*</span>
            </label>
            <v-select
              input-id="Degree"
              :options="degreeOptions"
              v-model="form.DegreeId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
              >ّ
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyEvidence }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="MilitaryService" class="ps_label">
              {{ label.form.militaryService }}
              <span class="ps_label_star">*</span>
            </label>
            <v-select
              input-id="MilitaryService"
              :options="militaryServiceOptions"
              v-model="form.MilitaryServiceId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
              >ّ
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyMilitaryService }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="Skills" class="ps_label">
              {{ label.form.skills }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="Skills"
              size="sm"
              v-model="form.Skills"
              type="text"
              class="text-end"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="WantedSalary" class="ps_label">
              {{ label.form.wantedSalary }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="WantedSalary"
              size="sm"
              v-model="form.WantedSalary"
              type="number"
              class="text-end"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="MobileNumber" class="ps_label">
              {{ label.form.mobileNumber }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="MobileNumber"
              size="sm"
              v-model="form.MobileNumber"
              type="number"
              class="text-end"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="PhoneNumber" class="ps_label">
              {{ label.form.phoneNumber }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="PhoneNumber"
              size="sm"
              v-model="form.PhoneNumber"
              type="number"
              class="text-end"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="Email" class="ps_label">
              {{ label.form.email }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="Email"
              size="sm"
              v-model="form.Email"
              type="text"
              class="text-end"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="Address" class="ps_label">
              {{ label.form.address }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="Address"
              size="sm"
              v-model="form.Address"
              type="text"
              class="text-end"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="workExperience" class="ps_label">
              {{ label.form.workExperience }}
            </label>
            <v-select
              input-id="workExperience"
              :options="workExperienceOptions"
              v-model="form.WorkExperience"
              :clearable="true"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
            >
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyList }}</span
                >
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="Specialty" class="ps_label">
              {{ label.form.specialty }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="Specialty"
              size="sm"
              v-model="form.Specialty"
              type="text"
              class="text-end"
            />
          </b-col>
          <b-col lg="8" md="8" sm="12" class="mt-3">
            <label for="Description" class="ps_label">
              {{ label.form.companyIntroduction }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-textarea
              id="Description"
              size="sm"
              v-model="form.Description"
              class="text-end"
            />
          </b-col>
          <b-col
            lg="4"
            md="4"
            sm="12"
            class="d-flex flex-column align-items-center profile-avatar mt-3"
          >
            <img
              v-if="logoSet"
              id="logob"
              :src="logoSet"
              alt="company logo"
              width="50%"
              height="100%"
              @click="clickLogo"
            />
            <label
              style="width: 50%; padding: 40px 0; text-align: center"
              @click="clickLogo"
              v-else
              for="avatarb"
              class="ps_label border border-1 rounded"
            >
              {{ label.form.companyLogo }}</label
            >
            <input
              type="file"
              ref="logo"
              id="logo"
              class="fs10 mt-1"
              hidden
              @change="handleFileUpload"
            />
          </b-col>

          <!-- Degree Histories -->
          <b-row class="mt-4 mb-2">
            <b-col cols="6" class="d-flex align-items-center">
              <h5 class="mt-1">{{ label.pages.add }} {{ label.pages.educationalRecords }}</h5>
              <b-icon
                icon="plus-square-fill"
                scale="1.2"
                variant="p-success"
                class="me-2 p-fs-n"
                @click="addDegreeHistories"
                style="cursor: pointer"
              ></b-icon>
            </b-col>
          </b-row>
          <b-row
            v-for="(degreeItem, degreeIndex) in form.DegreeHistories"
            :key="degreeIndex"
          >
            <b-col lg="4" md="12" sm="12" class="mt-3">
              <label for="University" class="ps_label">{{
                label.form.institute
              }}</label>
              <b-form-input
                id="University"
                size="md"
                v-model="degreeItem.University"
                type="text"
                class="text-center"
              />
            </b-col>
            <b-col lg="4" md="12" sm="12" class="mt-3">
              <label for="Field" class="ps_label">{{
                label.form.studyField
              }}</label>
              <b-form-input
                id="Field"
                size="md"
                v-model="degreeItem.Field"
                type="text"
                class="text-center"
              />
            </b-col>
            <b-col lg="4" md="12" sm="12" class="mt-3">
              <label for="Field" class="ps_label">{{
                label.form.educationTrend
              }}</label>
              <b-form-input
                id="Field"
                size="md"
                v-model="degreeItem.Major"
                type="text"
                class="text-center"
              />
            </b-col>
            <b-col lg="4" md="12" sm="12" class="mt-3">
              <label for="degree" class="ps_label">
                {{ label.form.educationDegree }}
                <span class="p-label__star">*</span>
              </label>
              <v-select
                input-id="degree"
                :options="degreeOptions"
                v-model="degreeItem.DegreeId"
                :clearable="false"
                :reduce="(item) => item.id"
                class="ps_select"
                size="md"
                >ّ
                <template #no-options>
                  <span class="p-select-no-option">
                    {{ label.captions.emptyEvidence }}
                  </span>
                </template>
              </v-select>
            </b-col>
            <b-col lg="4" md="12" sm="12" class="mt-3">
              <label for="FromDateLocal" class="ps_label pe-2">
                {{ label.form.fromDate }}
              </label>
              <date-picker
                v-model="degreeItem.FromDateLocal"
                :clearable="true"
                :editable="true"
                :auto-submit="true"
                type="date"
                color="#6AA435"
                class="ps_datePicker"
              />
            </b-col>
            <b-col lg="4" md="12" sm="12" class="mt-3">
              <b-row>
                <b-col lg="9" md="4" sm="6">
                  <label for="ToDateLocal" class="ps_label pe-2">
                    {{ label.form.toDate }}
                  </label>
                  <date-picker
                    v-model="degreeItem.ToDateLocal"
                    :clearable="true"
                    :editable="true"
                    :auto-submit="true"
                    type="date"
                    color="#6AA435"
                    class="ps_datePicker"
                  />
                </b-col>
                <b-col cols="1" class="mt-4 pt-1">
                  <b-button
                    :id="'degreeDelTlp-' + degreeIndex"
                    @click="delDegree(degreeIndex)"
                    variant="link"
                    size="sm"
                  >
                    <b-icon
                      icon="x-square-fill"
                      scale="0.8"
                      variant="ps-danger"
                    ></b-icon>
                  </b-button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    :target="'degreeDelTlp-' + degreeIndex"
                    triggers="hover"
                  >
                  {{ label.buttons.delete }}
                  </b-tooltip>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="1" class="mt-1"> </b-col>
          </b-row>
          <!-- Job Histories -->
          <b-row class="mt-4 mb-2">
            <b-col cols="6" class="d-flex align-items-center">
              <h5 class="mt-1"> {{ label.pages.add }} {{ label.pages.workExperience }}</h5>
              <b-icon
                icon="plus-square-fill"
                scale="1.2"
                variant="p-success"
                class="me-2 p-fs-n"
                @click="addJobHistories"
                style="cursor: pointer"
              ></b-icon>
            </b-col>
          </b-row>
          <b-row
            v-for="(jobHistoriesItem, jobHistoriesIndex) in form.JobHistories"
            :key="jobHistoriesIndex"
          >
            <b-col lg="4" md="8" class="mt-3">
              <label for="CompanyTitle" class="ps_label">
                {{ label.form.copmanyTitle }}</label
              >
              <b-form-input
                id="CompanyTitle"
                size="md"
                v-model="jobHistoriesItem.CompanyTitle"
                type="text"
                class="text-center"
              />
            </b-col>
            <b-col lg="4" md="8" class="mt-3">
              <label for="JobTitle" class="ps_label">{{
                label.form.post
              }}</label>
              <b-form-input
                id="JobTitle"
                size="md"
                v-model="jobHistoriesItem.JobTitle"
                type="text"
                class="text-center"
              />
            </b-col>
            <b-col lg="4" md="8" class="mt-3">
              <label for="CityId" class="ps_label">
                {{ label.form.province }}
              </label>
              <v-select
                input-id="CityId"
                :options="provinceOptions"
                v-model="jobHistoriesItem.CityId"
                :clearable="false"
                :reduce="(item) => item.id"
                class="ps_select"
                size="md"
              >
                <template #no-options>
                  <span class="p-select-no-option">
                    {{ label.captions.emptyProvince }}
                  </span>
                </template>
              </v-select>
            </b-col>
            <b-col lg="4" md="8" class="mt-3">
              <label for="FromDateLocal" class="ps_label pe-2">
                {{ label.form.fromDate }}
              </label>
              <date-picker
                v-model="jobHistoriesItem.FromDateLocal"
                :clearable="true"
                :editable="true"
                :auto-submit="true"
                type="date"
                color="#6AA435"
                class="ps_datePicker"
              />
            </b-col>
            <b-col lg="4" md="8" class="mt-3">
              <b-row>
                <b-col lg="11" md="4" sm="6">
                  <label for="ToDateLocal" class="ps_label pe-2">
                    {{ label.form.toDate }}
                  </label>
                  <date-picker
                    v-model="jobHistoriesItem.ToDateLocal"
                    :clearable="true"
                    :editable="true"
                    :auto-submit="true"
                    type="date"
                    color="#6AA435"
                    class="ps_datePicker"
                  />
                </b-col>
                <b-col cols="1" class="mt-4 pt-1">
                  <b-button
                    :id="'jobHistoriesDelTlp-' + jobHistoriesIndex"
                    @click="delJobHistories(jobHistoriesIndex)"
                    variant="link"
                    size="sm"
                  >
                    <b-icon
                      icon="x-square-fill"
                      scale="0.8"
                      variant="ps-danger"
                    ></b-icon>
                  </b-button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    :target="'jobHistoriesDelTlp-' + jobHistoriesIndex"
                    triggers="hover"
                  >
                  {{ label.buttons.delete }}
                  </b-tooltip>
                </b-col>
              </b-row>
              <div></div>

              <div></div>
            </b-col>
            <b-col cols="1" class="mt-1"> </b-col>
          </b-row>
          <!-- social media -->
          <b-row class="mt-4 mb-2">
            <b-col cols="6" class="d-flex align-items-center">
              <h5 class="mt-1">{{ label.pages.addSocialMedia }}</h5>
              <b-icon
                icon="plus-square-fill"
                scale="1.2"
                variant="p-success"
                class="me-2 p-fs-n"
                @click="addSocialAddress"
                style="cursor: pointer"
              ></b-icon>
            </b-col>
          </b-row>
          <b-row
            v-for="(socialItem, socialIndex) in form.SocialMediaLinks"
            :key="socialIndex"
          >
            <b-col lg="4" md="12" sm="12" class="mt-3">
              <label for="SocialMediaId" class="ps_label">
                {{ label.form.title }}
              </label>
              <v-select
                input-id="SocialMediaId"
                :options="socialMediaOptions"
                v-model="socialItem.SocialMediaId"
                :clearable="false"
                :reduce="(item) => item.id"
                class="ps_select"
                size="md"
              >
              </v-select>
            </b-col>
            <b-col lg="4" md="8" class="mt-3">
              <label for="address" class="ps_label">
                {{ label.form.address }}
              </label>
              <b-form-input
                id="address"
                size="md"
                v-model="socialItem.Address"
                type="text"
                class="text-center"
              />
            </b-col>
            <b-col lg="2" class="mt-4 pt-3">
              <b-button
                :id="'socialDelTlp-' + socialIndex"
                @click="delAddress(socialIndex)"
                variant="link"
                size="sm"
              >
                <b-icon
                  icon="x-square-fill"
                  scale="0.8"
                  variant="ps-danger"
                ></b-icon>
              </b-button>
              <b-tooltip
                boundary="#app"
                noninteractive
                :target="'socialDelTlp-' + socialIndex"
                triggers="hover"
              >
              {{ label.buttons.delete }}
              </b-tooltip>
            </b-col>
            <b-col cols="1" class="mt-3"> </b-col>
          </b-row>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="addModal = false"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              v-if="!loadingBtn"
              variant="ps-success"
              size="sm"
              class="mx-1"
              @click="addItem"
            >
              {{ label.buttons.submit }}
            </b-button>
            <b-button
              v-else
              variant="ps-success"
              size="sm"
              class="mx-1"
              disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- edit Modal -->
    <b-modal
      :dir="label.direction"
      v-model="editModal"
      header-bg-variant="ps-warning"
      centered
      size="xl"
    >
      <template #modal-header>
        <h4 class="text-white fw1">{{ label.pages.EditJobRequest }}</h4>
        <button
          class="ps-closeModalBtn"
          @click="editModal = false"
          v-b-tooltip.hover
          :title="label.buttons.closeModal"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
      </template>
      <b-container fluid>
        <b-row>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="FirstName" class="ps_label">
              {{ label.form.firstName }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="FirstName"
              size="sm"
              v-model="form.FirstName"
              type="text"
              class="text-end"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="LastName" class="ps_label">
              {{ label.form.lastName }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="LastName"
              size="sm"
              v-model="form.LastName"
              type="text"
              class="text-end"
            />
          </b-col>
          <b-col
            lg="4"
            md="6"
            sm="12"
            class="d-flex justify-content-center align-items-center mt-3"
          >
            <label for="Gender" class="ps_label ps-3">
              {{ label.form.gender }}:
            </label>
            <b-form-radio-group v-model="form.Gender" size="lg" class="d-flex">
              <b-form-radio :value="1" id="legal">
                <label for="legal" class="ps_label pe-0">
                  {{ label.form.sir }}
                </label>
              </b-form-radio>
              <b-form-radio :value="2" id="real" @change="clearSelect">
                <label for="real" class="ps_label pe-0">
                  {{ label.form.lady }}
                </label>
              </b-form-radio>
            </b-form-radio-group>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="BirthdateLocal" class="ps_label">
              {{ label.form.birthDate }}</label
            >
            <date-picker
              v-model="form.BirthdateLocal"
              :clearable="true"
              :editable="true"
              :auto-submit="true"
              type="date"
              color="#F4BB27"
              class="ps_datePicker"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="province" class="ps_label">
              {{ label.form.province }}
              <span class="ps_label_star">*</span>
            </label>
            <v-select
              input-id="province"
              :options="provinceOptions"
              v-model="form.ProvinceId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
              >ّ
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyProvince }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="MaritalStatus" class="ps_label">
              {{ label.form.maritalStatus }}
            </label>
            <v-select
              input-id="MaritalStatus"
              :options="MaritalOptions"
              v-model="form.MaritalStatus"
              :clearable="true"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
            >
              <template #no-options>
                <span class="p-select-no-option">{{
                  label.captions.emptyList
                }}</span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="UserId" class="ps_label">
              {{ label.form.user }}
              <span class="ps_label_star">*</span>
              <b-icon
                icon="question-circle-fill"
                scale="1.2"
                variant="ps-base"
                class="me-1 mouse-question"
                id="jobAddUserGuide"
              />
              <b-popover
                boundary="#app"
                placement="top"
                noninteractive
                triggers="hover"
                target="jobAddUserGuide"
                dir="rtl"
              >
                {{ label.guide.jobSeeker }}
              </b-popover>
            </label>
            <v-select
              input-id="UserId"
              :options="websiteUserOptions"
              v-model="form.UserId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
              >ّ
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyList }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="ActivityField" class="ps_label">
              {{ label.form.specializedNeeds }}
              <span class="ps_label_star">*</span>
            </label>
            <v-select
              input-id="ActivityField"
              :options="activityFieldOptions"
              v-model="form.ActivityFieldId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
              >ّ
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyList }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="Degree" class="ps_label">
              {{ label.form.educationDegree }}
              <span class="ps_label_star">*</span>
            </label>
            <v-select
              input-id="Degree"
              :options="degreeOptions"
              v-model="form.DegreeId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
              >ّ
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyEvidence }}
                </span>
              </template>
            </v-select>
          </b-col>

          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="MilitaryService" class="ps_label">
              {{ label.form.militaryService }}
              <span class="ps_label_star">*</span>
            </label>
            <v-select
              input-id="MilitaryService"
              :options="militaryServiceOptions"
              v-model="form.MilitaryServiceId"
              :clearable="false"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
              >ّ
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyMilitaryService }}
                </span>
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="Skills" class="ps_label">
              {{ label.form.skills }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="Skills"
              size="sm"
              v-model="form.Skills"
              type="text"
              class="text-end"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="WantedSalary" class="ps_label">
              {{ label.form.wantedSalary }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="WantedSalary"
              size="sm"
              v-model="form.WantedSalary"
              type="number"
              class="text-end"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="MobileNumber" class="ps_label">
              {{ label.form.mobileNumber }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="MobileNumber"
              size="sm"
              v-model="form.MobileNumber"
              type="number"
              class="text-end"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="PhoneNumber" class="ps_label">
              {{ label.form.phoneNumber }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="PhoneNumber"
              size="sm"
              v-model="form.PhoneNumber"
              type="number"
              class="text-end"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="Email" class="ps_label">
              {{ label.form.email }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="Email"
              size="sm"
              v-model="form.Email"
              type="text"
              class="text-end"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="Address" class="ps_label">
              {{ label.form.address }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="Address"
              size="sm"
              v-model="form.Address"
              type="text"
              class="text-end"
            />
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="workExperience" class="ps_label">
              {{ label.form.workExperience }}
            </label>
            <v-select
              input-id="workExperience"
              :options="workExperienceOptions"
              v-model="form.WorkExperience"
              :clearable="true"
              :reduce="(item) => item.id"
              class="ps_select"
              size="sm"
            >
              <template #no-options>
                <span class="p-select-no-option">
                  {{ label.captions.emptyList }}</span
                >
              </template>
            </v-select>
          </b-col>
          <b-col lg="4" md="6" sm="12" class="mt-3">
            <label for="Specialty" class="ps_label">
              {{ label.form.specialty }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input
              id="Specialty"
              size="sm"
              v-model="form.Specialty"
              type="text"
              class="text-end"
            />
          </b-col>

          <b-col lg="8" md="8" sm="12" class="mt-3">
            <label for="Description" class="ps_label">
              {{ label.form.companyIntroduction }}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-textarea
              id="Description"
              size="sm"
              v-model="form.Description"
              class="text-end"
            />
          </b-col>
          <b-col
            lg="4"
            md="4"
            sm="12"
            class="d-flex flex-column align-items-center profile-avatar mt-3"
          >
            <img
              v-if="logoSet"
              id="logob"
              :src="logoSet"
              alt="company logo"
              width="50%"
              height="100%"
              @click="clickLogo"
            />
            <label
              style="width: 50%; padding: 40px 0; text-align: center"
              @click="clickLogo"
              v-else
              for="avatarb"
              class="ps_label border border-1 rounded"
            >
              {{ label.form.companyLogo }}</label
            >
            <input
              type="file"
              ref="logo"
              id="logo"
              class="fs10 mt-1"
              hidden
              @change="handleFileUpload"
            />
          </b-col>

          <!-- Degree Histories -->
          <b-row class="mt-4 mb-2">
            <b-col cols="6" class="d-flex align-items-center">
              <h5 class="mt-1">افزودن سوابق تحصیلی</h5>
              <b-icon
                icon="plus-square-fill"
                scale="1.2"
                variant="p-success"
                class="me-2 p-fs-n"
                @click="addDegreeHistories"
                style="cursor: pointer"
              ></b-icon>
            </b-col>
          </b-row>
          <b-row
            v-for="(degreeItem, degreeIndex) in form.DegreeHistories"
            :key="degreeIndex"
          >
            <b-col lg="4" md="12" sm="12" class="mt-3">
              <label for="University" class="ps_label">{{
                label.form.institute
              }}</label>
              <b-form-input
                id="University"
                size="md"
                v-model="degreeItem.University"
                type="text"
                class="text-center"
              />
            </b-col>
            <b-col lg="4" md="12" sm="12" class="mt-3">
              <label for="Field" class="ps_label">{{
                label.form.studyField
              }}</label>
              <b-form-input
                id="Field"
                size="md"
                v-model="degreeItem.Field"
                type="text"
                class="text-center"
              />
            </b-col>
            <b-col lg="4" md="12" sm="12" class="mt-3">
              <label for="Field" class="ps_label">{{
                label.form.educationTrend
              }}</label>
              <b-form-input
                id="Field"
                size="md"
                v-model="degreeItem.Major"
                type="text"
                class="text-center"
              />
            </b-col>
            <b-col lg="4" md="12" sm="12" class="mt-3">
              <label for="degree" class="ps_label">
                {{ label.form.educationDegree }}
                <span class="p-label__star">*</span>
              </label>
              <v-select
                input-id="degree"
                :options="degreeOptions"
                v-model="degreeItem.DegreeId"
                :clearable="false"
                :reduce="(item) => item.id"
                class="ps_select"
                size="md"
                >ّ
                <template #no-options>
                  <span class="p-select-no-option">
                    {{ label.captions.emptyEvidence }}
                  </span>
                </template>
              </v-select>
            </b-col>
            <b-col lg="4" md="12" sm="12" class="mt-3">
              <label for="FromDateLocal" class="ps_label pe-2">
                {{ label.form.fromDate }}
              </label>
              <date-picker
                v-model="degreeItem.FromDateLocal"
                :clearable="true"
                :editable="true"
                :auto-submit="true"
                type="date"
                color="#F4BB27"
                class="ps_datePicker"
              />
            </b-col>
            <b-col lg="4" md="12" sm="12" class="mt-3">
              <b-row>
                <b-col lg="9" md="4" sm="6">
                  <label for="ToDateLocal" class="ps_label pe-2">
                    {{ label.form.toDate }}
                  </label>
                  <date-picker
                    v-model="degreeItem.ToDateLocal"
                    :clearable="true"
                    :editable="true"
                    :auto-submit="true"
                    type="date"
                    color="#F4BB27"
                    class="ps_datePicker"
                  />
                </b-col>
                <b-col cols="1" class="mt-4 pt-1">
                  <b-button
                    :id="'degreeDelTlp-' + degreeIndex"
                    @click="delDegree(degreeIndex)"
                    variant="link"
                    size="sm"
                  >
                    <b-icon
                      icon="x-square-fill"
                      scale="0.8"
                      variant="ps-danger"
                    ></b-icon>
                  </b-button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    :target="'degreeDelTlp-' + degreeIndex"
                    triggers="hover"
                  >
                    حذف
                  </b-tooltip>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="1" class="mt-1"> </b-col>
          </b-row>
          <!-- Job Histories -->
          <b-row class="mt-4 mb-2">
            <b-col cols="6" class="d-flex align-items-center">
              <h5 class="mt-1">{{ label.pages.add }} {{ label.pages.workExperience }}</h5>
              <b-icon
                icon="plus-square-fill"
                scale="1.2"
                variant="p-success"
                class="me-2 p-fs-n"
                @click="addJobHistories"
                style="cursor: pointer"
              ></b-icon>
            </b-col>
          </b-row>
          <b-row
            v-for="(jobHistoriesItem, jobHistoriesIndex) in form.JobHistories"
            :key="jobHistoriesIndex"
          >
            <b-col lg="4" md="8" class="mt-3">
              <label for="CompanyTitle" class="ps_label">
                {{ label.form.copmanyTitle }}</label
              >
              <b-form-input
                id="CompanyTitle"
                size="md"
                v-model="jobHistoriesItem.CompanyTitle"
                type="text"
                class="text-center"
              />
            </b-col>
            <b-col lg="4" md="8" class="mt-3">
              <label for="JobTitle" class="ps_label">{{
                label.form.post
              }}</label>
              <b-form-input
                id="JobTitle"
                size="md"
                v-model="jobHistoriesItem.JobTitle"
                type="text"
                class="text-center"
              />
            </b-col>
            <b-col lg="4" md="8" class="mt-3">
              <label for="CityId" class="ps_label">
                {{ label.form.province }}
              </label>
              <v-select
                input-id="CityId"
                :options="provinceOptions"
                v-model="jobHistoriesItem.CityId"
                :clearable="false"
                :reduce="(item) => item.id"
                class="ps_select"
                size="md"
              >
                <template #no-options>
                  <span class="p-select-no-option">
                    {{ label.captions.emptyProvince }}
                  </span>
                </template>
              </v-select>
            </b-col>
            <b-col lg="4" md="8" class="mt-3">
              <label for="FromDateLocal" class="ps_label pe-2">
                {{ label.form.fromDate }}
              </label>
              <date-picker
                v-model="jobHistoriesItem.FromDateLocal"
                :clearable="true"
                :editable="true"
                :auto-submit="true"
                type="date"
                color="#F4BB27"
                class="ps_datePicker"
              />
            </b-col>
            <b-col lg="4" md="8" class="mt-3">
              <b-row>
                <b-col lg="11" md="4" sm="6">
                  <label for="ToDateLocal" class="ps_label pe-2">
                    {{ label.form.toDate }}
                  </label>
                  <date-picker
                    v-model="jobHistoriesItem.ToDateLocal"
                    :clearable="true"
                    :editable="true"
                    :auto-submit="true"
                    type="date"
                    color="#F4BB27"
                    class="ps_datePicker"
                  />
                </b-col>
                <b-col cols="1" class="mt-4 pt-1">
                  <b-button
                    :id="'jobHistoriesDelTlp-' + jobHistoriesIndex"
                    @click="delJobHistories(jobHistoriesIndex)"
                    variant="link"
                    size="sm"
                  >
                    <b-icon
                      icon="x-square-fill"
                      scale="0.8"
                      variant="ps-danger"
                    ></b-icon>
                  </b-button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    :target="'jobHistoriesDelTlp-' + jobHistoriesIndex"
                    triggers="hover"
                  >
                    حذف
                  </b-tooltip>
                </b-col>
              </b-row>
              <div></div>

              <div></div>
            </b-col>
            <b-col cols="1" class="mt-1"> </b-col>
          </b-row>
          <!-- social media -->
          <b-row class="mt-4 mb-2">
            <b-col cols="6" class="d-flex align-items-center">
              <h5 class="mt-1">{{ label.pages.addSocialMedia }}</h5>
              <b-icon
                icon="plus-square-fill"
                scale="1.2"
                variant="p-success"
                class="me-2 p-fs-n"
                @click="addSocialAddress"
                style="cursor: pointer"
              ></b-icon>
            </b-col>
          </b-row>
          <b-row
            v-for="(socialItem, socialIndex) in form.SocialMediaLinks"
            :key="socialIndex"
          >
            <b-col lg="4" md="12" sm="12" class="mt-3">
              <label for="SocialMediaId" class="ps_label">
                {{ label.form.title }}
              </label>
              <v-select
                input-id="SocialMediaId"
                :options="socialMediaOptions"
                v-model="socialItem.SocialMediaId"
                :clearable="false"
                :reduce="(item) => item.id"
                class="ps_select"
                size="md"
              >
              </v-select>
            </b-col>
            <b-col lg="4" md="8" class="mt-3">
              <label for="address" class="ps_label">
                {{ label.form.address }}
              </label>
              <b-form-input
                id="address"
                size="md"
                v-model="socialItem.Address"
                type="text"
                class="text-center"
              />
            </b-col>
            <b-col lg="2" class="mt-4 pt-3">
              <b-button
                :id="'socialDelTlp-' + socialIndex"
                @click="delAddress(socialIndex)"
                variant="link"
                size="sm"
              >
                <b-icon
                  icon="x-square-fill"
                  scale="0.8"
                  variant="ps-danger"
                ></b-icon>
              </b-button>
              <b-tooltip
                boundary="#app"
                noninteractive
                :target="'socialDelTlp-' + socialIndex"
                triggers="hover"
              >
              {{ label.buttons.delete }}
              </b-tooltip>
            </b-col>
            <b-col cols="1" class="mt-3"> </b-col>
          </b-row>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="editModal = false"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              v-if="!loadingBtn"
              variant="ps-warning"
              size="sm"
              class="mx-1"
              @click="editItem"
            >
              {{ label.buttons.saveChanges }}
            </b-button>
            <b-button
              v-else
              variant="ps-warning"
              size="sm"
              class="mx-1"
              disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Delete Confirm Modal -->
    <b-modal
      :dir="label.direction"
      v-model="delModal"
      hide-header
      centered
      size="sm"
    >
      <b-container fluid>
        <b-row class="mt-2">
          <p class="fs10 text-center lh1 mb-0">
            {{ label.pages.sureDeleteAds }}
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="closeModal()"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              v-if="!loadingBtn"
              variant="ps-danger"
              size="sm"
              class="mx-1"
              @click="deleteItem"
            >
              {{ label.buttons.deleteConfirm }}
            </b-button>
            <b-button
              v-else
              disabled
              variant="ps-danger"
              size="sm"
              class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { dataGridMixin } from "@/components/dataGrid/dataGridMixin";
import label from "@/plugins/StaticLabels.js";
import { contentLanguage } from "@/plugins/ContentLangMixin.js";
import moment from "moment-jalaali";
const startMonth = moment().startOf("jM").format("jYYYY/jMM/jDD");
const endMonth = moment().endOf("jM").format("jYYYY/jMM/jDD");

export default {
  name: "jobRequests",
  mixins: [dataGridMixin, contentLanguage],
  components: {},
  data() {
    return {
      fromDateLocal: startMonth,
      toDateLocal: endMonth,
      refreshImage: true,
      dropZoneAction: true,
      file: null,
      label,
      delId: null,
      delTitle: "",
      itemId: null,
      detailModal: false,
      detailJobModal: false,
      itemDetailJobId: false,
      statusModal: false,
      statusId: null,
      status: null,
      jobRequestFields: [
        {
          cellTemplate: "radif",
          caption: label.table.row,
          allowSorting: false,
          allowFiltering: false,
          width: "100",
          cssClass: "text-center align-middle",
        },
        {
          cellTemplate: "actions",
          caption: label.table.actions,
          allowSorting: false,
          allowFiltering: false,
          width: "150",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "id",
          caption: label.table.AdCode,
          dataType: "string",
          cssClass: "text-center align-middle fw2",
        },
        {
          dataField: "firstName",
          caption: label.table.firstName,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "lastName",
          caption: label.table.lastName,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          cellTemplate: "image",
          caption: label.table.image,
          allowSorting: false,
          allowFiltering: false,
          width: "100",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "activityFieldTitle",
          caption: label.table.specializedNeeds,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "birthdateLocal",
          caption: label.table.birthDate,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "email",
          caption: label.table.email,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "maritalStatusTitle",
          caption: label.table.maritalStatus,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "phoneNumber",
          caption: label.table.phoneNumber,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "genderTitle",
          caption: label.table.gender,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "mobileNumber",
          caption: label.table.mobile,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "militaryServiceTitle",
          caption: label.table.militaryService,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "provinceTitle",
          caption: label.table.province,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "wantedSalary",
          caption: label.table.wantedSalary,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "skills",
          caption: label.table.skills,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "specialty",
          caption: label.table.specialty,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "workExperienceTitle",
          caption: label.table.workExperience,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "creatorName",
          caption: label.table.registeredUser,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "status",
          caption: label.table.status,
          dataType: "boolean",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "description",
          caption: label.table.description,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "address",
          caption: label.table.address,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
      ],
      detailForm: [],
      detailFields: [
        {
          dataField: "degreeTitle",
          caption: label.table.educationDegree,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "field",
          caption: label.table.studyField,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "fromDateLocal",
          caption: label.table.studyStartDate,
          dataType: "string",
          cssClass: "text-center",
        },
        {
          dataField: "toDateLocal",
          caption: label.table.studyEndDate,
          dataType: "string",
          cssClass: "text-center",
        },
      ],
      detailJobForm: [],
      detailJobFields: [
        {
          dataField: "cityTitle",
          caption: label.table.residenceProvince,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "companyTitle",
          caption: label.table.copmanyTitle,
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "fromDateLocal",
          caption: label.table.workStartDate,
          dataType: "string",
          cssClass: "text-center",
        },
        {
          dataField: "toDateLocal",
          caption: label.table.workEndDate,
          dataType: "string",
          cssClass: "text-center",
        },
        {
          dataField: "jobTitle",
          caption: label.table.activity,
          dataType: "string",
          cssClass: "text-center",
        },
      ],
      addModal: false,
      form: {
        FirstName: null,
        LastName: null,
        MaritalStatus: null,
        BirthdateLocal: null,
        MobileNumber: null,
        PhoneNumber: null,
        Email: null,
        ProvinceId: null,
        Address: null,
        ActivityFieldId: null,
        DegreeId: null,
        Specialty: null,
        Skills: null,
        WantedSalary: null,
        WorkExperience: null,
        Gender: null,
        MilitaryServiceId: null,
        Image: null,
        Description: null,
        UserId: null,
        DegreeHistories: [],
        JobHistories: [],
        SocialMediaLinks: [],
      },
      itemDetailId: null,
      editModal: false,
      delModal: false,
      logoSet: null,
    };
  },
  computed: {
    ...mapGetters({
      postCheck: "postCheck",
      jobRequest: "baseX/jobRequest",
      loadingBtn: "loadingBtn",
      imageUrl: "imageUrl",
      provinceOptions: "baseX/provinceOptions",
      activityFieldOptions: "baseX/activityFieldOptions",
      degreeOptions: "baseX/degreeOptions",
      militaryServiceOptions: "baseX/militaryServiceOptions",
      socialMediaOptions: "baseX/socialMediaOptions",
      websiteUserOptions: "baseX/websiteUserOptions",
      workExperienceOptions: "baseX/workExperienceOptions",
      MaritalOptions: "baseX/MaritalOptions",
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.reloadData();
        this.reloadFields();
        this.closeModal();
      }
    },
  },
  methods: {
    showDegreeDetail(item) {
      this.itemDetailId = item.data.id;
      this.detailModal = true;
      this.detailForm = item.data.degreeHistories;
    },
    showJobDetail(item) {
      this.itemDetailJobId = item.data.id;
      this.detailJobModal = true;
      this.detailJobForm = item.data.jobHistories;
    },
    clearSelect() {
      if (this.form.Gender === 2) {
        this.form.MilitaryServiceId = null;
      }
    },
    clickLogo() {
      this.$refs.logo.click();
    },
    handleFileUpload() {
      this.form.Image = this.$refs.logo.files[0];
      this.logoSet = URL.createObjectURL(this.form.Image);
    },
    addSocialAddress() {
      const payload = {
        SocialMediaId: null,
        Address: null,
      };
      this.form.SocialMediaLinks.push(payload);
    },
    delAddress(index) {
      this.form.SocialMediaLinks.splice(index, 1);
    },
    addDegreeHistories() {
      const payload = {
        University: null,
        FromDateLocal: null,
        ToDateLocal: null,
      };
      this.form.DegreeHistories.push(payload);
    },
    addJobHistories() {
      const payload = {
        CompanyTitle: null,
        FromDateLocal: null,
        ToDateLocal: null,
      };
      this.form.JobHistories.push(payload);
    },
    delDegree(index) {
      this.form.DegreeHistories.splice(index, 1);
    },
    delJobHistories(index) {
      this.form.JobHistories.splice(index, 1);
    },
    add() {
      this.reloadFields();
      this.addModal = true;
    },
    addItem() {
      if (this.form) {
        let formData = new FormData();
        formData.append("FirstName", this.form.FirstName);
        formData.append("LastName", this.form.LastName);
        formData.append("MaritalStatus", this.form.MaritalStatus);
        formData.append("BirthdateLocal", this.form.BirthdateLocal);
        formData.append("MobileNumber", this.form.MobileNumber);
        formData.append("PhoneNumber", this.form.PhoneNumber);
        formData.append("Email", this.form.Email);
        formData.append("ProvinceId", this.form.ProvinceId);
        if (this.form.Address) {
          formData.append("Address", this.form.Address);
        }
        if (this.form.ActivityFieldId) {
          formData.append("ActivityFieldId", this.form.ActivityFieldId);
        }
        if (this.form.DegreeId) {
          formData.append("DegreeId", this.form.DegreeId);
        }
        if (this.form.Specialty) {
          formData.append("Specialty", this.form.Specialty);
        }
        if (this.form.Skills) {
          formData.append("Skills", this.form.Skills);
        }
        if (this.form.WantedSalary) {
          formData.append("WantedSalary", this.form.WantedSalary);
        }
        if (this.form.WorkExperience) {
          formData.append("WorkExperience", this.form.WorkExperience);
        }
        if (this.form.Gender) {
          formData.append("Gender", this.form.Gender);
        }
        if (this.form.MilitaryServiceId) {
          formData.append("MilitaryServiceId", this.form.MilitaryServiceId);
        }
        if (this.form.Image) {
          formData.append("Image", this.form.Image);
        }
        if (this.form.Description) {
          formData.append("Description", this.form.Description);
        }
        if (this.form.UserId) {
          formData.append("UserId", this.form.UserId);
        }
        if (this.form.DegreeHistories && this.form.DegreeHistories.length > 0) {
          this.form.DegreeHistories.forEach((item, i) => {
            formData.append("DegreeHistories[" + i + "].Field", item.Field);
            formData.append("DegreeHistories[" + i + "].Major", item.Major);
            formData.append(
              "DegreeHistories[" + i + "].University",
              item.University
            );
            formData.append(
              "DegreeHistories[" + i + "].FromDateLocal",
              item.FromDateLocal
            );
            formData.append(
              "DegreeHistories[" + i + "].ToDateLocal",
              item.ToDateLocal
            );
            formData.append(
              "DegreeHistories[" + i + "].DegreeId",
              item.DegreeId
            );
          });
        }
        if (this.form.JobHistories && this.form.JobHistories.length > 0) {
          this.form.JobHistories.forEach((item, i) => {
            formData.append("JobHistories[" + i + "].JobTitle", item.JobTitle);
            formData.append(
              "JobHistories[" + i + "].CompanyTitle",
              item.CompanyTitle
            );
            formData.append(
              "JobHistories[" + i + "].FromDateLocal",
              item.FromDateLocal
            );
            formData.append(
              "JobHistories[" + i + "].ToDateLocal",
              item.ToDateLocal
            );
            formData.append("JobHistories[" + i + "].CityId", item.CityId);
          });
        }
        if (
          this.form.SocialMediaLinks &&
          this.form.SocialMediaLinks.length > 0
        ) {
          this.form.SocialMediaLinks.forEach((item, i) => {
            formData.append(
              "SocialMediaLinks[" + i + "].SocialMediaId",
              item.SocialMediaId
            );
            formData.append(
              "SocialMediaLinks[" + i + "].Address",
              item.Address
            );
          });
        }
        this.$store.dispatch("baseX/addJobRequest", formData);
      } else {
        this.$store.commit("setError", "فیلدهای الزامی را پر کنید");
      }
    },
    edit(item) {
      this.itemId = item.data.id;
      this.form = {
        FirstName: item.data.firstName,
        LastName: item.data.lastName,
        MaritalStatus: item.data.maritalStatus,
        BirthdateLocal: item.data.birthdateLocal,
        MobileNumber: item.data.mobileNumber,
        PhoneNumber: item.data.phoneNumber,
        Email: item.data.email,
        ProvinceId: item.data.provinceId,
        Address: item.data.address,
        ActivityFieldId: item.data.activityFieldId,
        DegreeId: item.data.degreeId,
        Specialty: item.data.specialty,
        Skills: item.data.skills,
        WantedSalary: item.data.wantedSalary,
        WorkExperience: item.data.workExperience,
        Gender: item.data.gender,
        MilitaryServiceId: item.data.militaryServiceId,
        Image: item.data.image,
        Description: item.data.description,
        UserId: item.data.userId,
        DegreeHistories: [],
        JobHistories: [],
        SocialMediaLinks: [],
      };
      this.logoSet = item.data.imageAddress;
      item.data.socialMediaLinks.forEach((z) => {
        const payload = {
          SocialMediaId: z.socialMediaId,
          Address: z.address,
        };
        this.form.SocialMediaLinks.push(payload);
      }),
        item.data.jobHistories.forEach((n) => {
          const payload = {
            JobTitle: n.jobTitle,
            CompanyTitle: n.companyTitle,
            FromDateLocal: n.fromDateLocal,
            ToDateLocal: n.toDateLocal,
            CityId: n.cityId,
          };
          this.form.JobHistories.push(payload);
        }),
        item.data.degreeHistories.forEach((z) => {
          const payload = {
            Field: z.field,
            Major: z.major,
            University: z.university,
            FromDateLocal: z.fromDateLocal,
            ToDateLocal: z.toDateLocal,
            DegreeId: z.degreeId,
          };
          this.form.DegreeHistories.push(payload);
        }),
      this.editModal = true;
    },
    editItem() {
      let formData = new FormData();
      if (this.form.FirstName) {
        formData.append("FirstName", this.form.FirstName);
      }
      if (this.form.LastName) {
        formData.append("LastName", this.form.LastName);
      }
      if (this.form.MaritalStatus) {
        formData.append("MaritalStatus", this.form.MaritalStatus);
      }
      if (this.form.BirthdateLocal) {
        formData.append("BirthdateLocal", this.form.BirthdateLocal);
      }
      if (this.form.MobileNumber) {
        formData.append("MobileNumber", this.form.MobileNumber);
      }
      if (this.form.PhoneNumber) {
        formData.append("PhoneNumber", this.form.PhoneNumber);
      }
      if (this.form.Email) {
        formData.append("Email", this.form.Email);
      }
      if (this.form.ProvinceId) {
        formData.append("ProvinceId", this.form.ProvinceId);
      }
      if (this.form.Address) {
        formData.append("Address", this.form.Address);
      }
      if (this.form.ActivityFieldId) {
        formData.append("ActivityFieldId", this.form.ActivityFieldId);
      }
      if (this.form.DegreeId) {
        formData.append("DegreeId", this.form.DegreeId);
      }
      if (this.form.Specialty) {
        formData.append("Specialty", this.form.Specialty);
      }
      if (this.form.Skills) {
        formData.append("Skills", this.form.Skills);
      }
      if (this.form.WantedSalary) {
        formData.append("WantedSalary", this.form.WantedSalary);
      }
      if (this.form.WorkExperience) {
        formData.append("WorkExperience", this.form.WorkExperience);
      }
      if (this.form.Gender) {
        formData.append("Gender", this.form.Gender);
      }
      if (this.form.MilitaryServiceId) {
        formData.append("MilitaryServiceId", this.form.MilitaryServiceId);
      }
      if (this.form.Image) {
        formData.append("Image", this.form.Image);
      }
      if (this.form.Description) {
        formData.append("Description", this.form.Description);
      }
      if (this.form.UserId) {
        formData.append("UserId", this.form.UserId);
      }
      if (this.form.DegreeHistories && this.form.DegreeHistories.length > 0) {
        this.form.DegreeHistories.forEach((item, i) => {
          formData.append("DegreeHistories[" + i + "].Field", item.Field);
          formData.append("DegreeHistories[" + i + "].Major", item.Major);
          formData.append(
            "DegreeHistories[" + i + "].University",
            item.University
          );
          formData.append(
            "DegreeHistories[" + i + "].FromDateLocal",
            item.FromDateLocal
          );
          formData.append(
            "DegreeHistories[" + i + "].ToDateLocal",
            item.ToDateLocal
          );
          formData.append("DegreeHistories[" + i + "].DegreeId", item.DegreeId);
        });
      }
      if (this.form.JobHistories && this.form.JobHistories.length > 0) {
        this.form.JobHistories.forEach((item, i) => {
          formData.append("JobHistories[" + i + "].JobTitle", item.JobTitle);
          formData.append(
            "JobHistories[" + i + "].CompanyTitle",
            item.CompanyTitle
          );
          formData.append(
            "JobHistories[" + i + "].FromDateLocal",
            item.FromDateLocal
          );
          formData.append(
            "JobHistories[" + i + "].ToDateLocal",
            item.ToDateLocal
          );
          formData.append("JobHistories[" + i + "].CityId", item.CityId);
        });
      }
      if (this.form.SocialMediaLinks && this.form.SocialMediaLinks.length > 0) {
        this.form.SocialMediaLinks.forEach((item, i) => {
          formData.append(
            "SocialMediaLinks[" + i + "].SocialMediaId",
            item.SocialMediaId
          );
          formData.append("SocialMediaLinks[" + i + "].Address", item.Address);
        });
      }
      const payload = {
        id: this.itemId,
        value: formData,
      };
      this.$store.dispatch("baseX/editJobRequest", payload);
    },
    delConfirm(item) {
      this.itemId = item.data.id;
      this.delModal = true;
    },
    deleteItem() {
      this.$store.dispatch("baseX/deleteJobRequest", this.itemId);
      this.closeModal();
    },
    reloadFields() {
      this.form = {
        FirstName: null,
        LastName: null,
        MaritalStatus: null,
        BirthdateLocal: null,
        MobileNumber: null,
        PhoneNumber: null,
        Email: null,
        ProvinceId: null,
        Address: null,
        ActivityFieldId: null,
        DegreeId: null,
        Specialty: null,
        Skills: null,
        WantedSalary: null,
        WorkExperience: null,
        Gender: 1,
        MilitaryServiceId: null,
        Image: null,
        Description: null,
        UserId: null,
        DegreeHistories: [],
        JobHistories: [],
        SocialMediaLinks: [],
      };
    },
    closeModal() {
      this.delModal = false;
      this.editModal = false;
      this.addModal = false;
      this.statusModal = false;
    },
    reloadData() {
      let payload = "pageNumber=1&pageSize=10000000";
      if(this.fromDateLocal) {
        payload += "&fromDate=" + this.fromDateLocal;
      }
      if(this.toDateLocal) {
        payload += "&toDate=" + this.toDateLocal;
      }
      this.$store.dispatch("baseX/getJobRequest", payload);
    },
    statusConfirm(item) {
      this.statusId = item.data.id;
      this.status = item.data.status;
      this.statusModal = true;
    },
    changeStatus() {
      const payload = {
        id: this.statusId,
        status: this.status,
      };
      this.$store.dispatch("baseX/changeStatusJobRequest", payload);
      this.closeModal();
    },
  },
  mounted() {
    this.reloadData();
    this.$store.dispatch("baseX/getProvince");
    this.$store.dispatch("baseX/getActivityFields");
    this.$store.dispatch("baseX/getDegree");
    this.$store.dispatch("baseX/getMilitaryService");
    this.$store.dispatch("baseX/getSocialMedia");
    this.$store.dispatch("baseX/getWebsiteUser");
  },
};
</script>

<style>
.custom-p-select {
  width: 170px;
}
</style>
